import { Component, computed, inject } from '@angular/core';
import { MobileFrameService, MobilePagePart } from '@eforall/mobile';


@Component({
	selector: 'procedures-page',
	imports: [
		MobilePagePart,
	],
	templateUrl: './procedures.page.html'
})

export class ProceduresPage {
	private frame = inject(MobileFrameService);

	constructor() {
		this.frame.setUrlMetadata({
			url: '/procedures',
			backUrl: '/',
			pageName: computed(() => `Procedures`),
			headerText: computed(() => `Procedures`),
		});
	}

}